import { $fetch } from '@/plugins/Fetch'
/**
 * 客户管理相关接口
 * amujoe
 */
export default {
  methods: {
    // ***************************会员积分充值 9.4 start zhangxiang***************************
    // 会员设置详情
    pointDetailApi (param) {
      return $fetch('point/setting/detail', {
        method: 'POST',
        body: param,
      })
    },
    // 会员设置 point/setting
    pointSettingApi (param) {
      return $fetch('point/setting', {
        method: 'POST',
        body: param,
      })
    },
    // 积分列表 point/list
    pointListApi (params) {
      return $fetch('point/list', {
        method: 'POST',
        body: params,
      })
    },
    // 积分详情用户
    pointUserDetailApi (params) {
      return $fetch('point/customer_detail', {
        method: 'POST',
        body: params,
      })
    },
    // 积分详情--列表
    pointUserDetailListApi (params) {
      return $fetch('point/customer_record', {
        method: 'POST',
        body: params,
      })
    },
    // 积分扣减
    pointUserReduceApi (params) {
      return $fetch('point/deduction_points', {
        method: 'POST',
        body: params,
      })
    },
    // 客户管理权限展示
    authController (params) {
      return $fetch('store_white/get_white_info', {
        method: 'POST',
        body: params,
      })
    },
    // 充值接口
    customerRechargeApi (params) {
      return $fetch('customer/customer_recharge', {
        method: 'POST',
        body: params,
      })
    },
    // balance/count 用户余额统计
    userBalanceCountApi (params) {
      return $fetch('balance/count', {
        method: 'POST',
        body: params,
      })
    },
    // 用户充值记录
    userRechargeListApi (params) {
      return $fetch('balance/recharge_list', {
        method: 'POST',
        body: params,
      })
    },
    // 用户余额支付记录
    userConsumeListApi (params) {
      return $fetch('balance/consume_list', {
        method: 'POST',
        body: params,
      })
    },
    // 安全确认admins/security
    userSecurity () {
      return $fetch('admins/security', {
        method: 'POST',
      })
    },
    // 是否开通过余额充值
    // ***************************会员积分充值 9.4 end zhangxiang***************************
    // 客户管理 - 客户管理列表
    fetchCustomerList (query) {
      return $fetch('customer/get_customer_list', {
        method: 'POST',
        body: query,
      })
    },
    // 客户管理 - 关联手机号
    relationCustomerApi (query) {
      return $fetch('customer/relation_customer', {
        method: 'POST',
        body: query,
      })
    },
    // 客户管理 - 解除关联用户
    delCustomerRelationApi (query) {
      return $fetch('customer/del_customer_relation', {
        method: 'POST',
        body: query,
      })
    },
    // 客户管理 - 查询关联用户信息
    getMiniCustomerListApi (query) {
      return $fetch('customer/get_mini_customer_list', {
        method: 'POST',
        body: query,
      })
    },
    // 客户管理 - 客户详情
    fetchCustomerDetail (id) {
      return $fetch(`customer/${id}`)
    },
    // 客户管理 - 改备注
    setCustomerRemarkApi (param) {
      return $fetch('customer/customer_remarks_update', {
        method: 'POST',
        body: param,
      })
    },
    // 客户管理 - 客户消费列表
    fetchCustomerConsume (query) {
      return $fetch('new_order/list_by_customer', { query })
    },
    // 客户管理 - 车检报告列表
    fetchInspectListApi (query) {
      return $fetch('inspect/list', { query })
    },
    // 客户管理 - 车检报告详情
    fetchInspectDetailApi (query) {
      return $fetch('inspect/detail', { query })
    },
    // 客户管理 - 养护卡列表
    fetchCardListApi (query) {
      return $fetch('upkeep/customer', { query })
    },
    // 客户管理 - 养护卡详情
    fetchCardDetailApi (query) {
      return $fetch('upkeep/detail', { query })
    },
    // 客户管理 - 养护卡详情
    fetchCardCountDetailApi (query) {
      return $fetch('upkeep/detail_count', { query })
    },
    // 客户管理 - 车辆里程记录
    fetchMileageRecordApi (query) {
      return $fetch('customer/vehicle/vehicle-mileage-record', { query })
    },
    // 养护卡使用记录 upkeep/customer_use
    fetchCardUserApi (query) {
      return $fetch('upkeep/customer_use', { query })
    },
    // 养护卡分享记录 upkeep/customer_use
    fetchCardShareApi (query) {
      return $fetch('upkeep/customer_share', { query })
    },
    // 基础库养护卡关联商品
    fetchCardGoodsApi (query) {
      return $fetch('upkeep/depot_product', { query })
    },
    // 养护卡镜像详情
    fetchCardDetailTwoApi (query) {
      return $fetch('upkeep/detail_iso', { query })
    },
    // 养护卡价格变更记录
    fetchCardPriceRecordApi (query) {
      return $fetch('upkeep/price_logs', { query })
    },
    // 车辆品牌列表
    fetchCarBrandsApi (query) {
      return $fetch('common/inspect/brands', { query })
    },
    // 车型列表
    fetchCarModelsApi (vehicleBrandId) {
      return $fetch(`common/inspect/models/${vehicleBrandId}`)
    },
    // 车型具体销售版本列表
    fetchCarSalesApi (vehicleModelId) {
      return $fetch(`common/inspect/vehicles/${vehicleModelId}`)
    },
    // 客户管理 - 客户车辆详情
    fetchCarDetailApi (query) {
      return $fetch('customer/vehicle/detail', { query })
    },
    // 根据ip地址获取所在地省份简称
    fetchProvinceByIPApi (query) {
      return $fetch('common/province', { query })
    },
    // 客户管理 - 新增客户车辆
    addCarApi (body) {
      return $fetch('customer/vehicle/add', {
        method: 'POST',
        body: body,
      })
    },
    // 客户管理 - 编辑客户车辆
    editCarApi (body) {
      return $fetch('customer/vehicle/edit', {
        method: 'POST',
        body: body,
      })
    },
    // 客户管理 - 删除客户车辆
    deleteCarApi (body) {
      return $fetch('customer/vehicle/delete', {
        method: 'POST',
        body: body,
      })
    },
    // 客户管理 - 用户储值卡列表
    getUpkeepCustomerStoredCardListApi (body) {
      return $fetch('upkeep/customer_stored_card_list', {
        method: 'POST',
        body: body,
      })
    },
    // 客户管理 - 用户储值卡余额交易明细列表
    getUpkeepCustomerStoredCardConsumeListApi (body) {
      return $fetch('upkeep/customer_stored_consume_list', {
        method: 'POST',
        body: body,
      })
    },
    // 客户管理 - 用户储值卡余额信息
    getUpkeepCustomerStoredBalanceApi (query) {
      return $fetch('upkeep/customer_stored_balance', {
        method: 'GET',
        body: query,
      })
    },
    /**
     * 更新养护卡（仅养护卡&次卡）到期时间
     * @param {*} body
     * @returns
     */
    updateExpirationDateApi (body) {
      return $fetch('upkeep/upkeep_expiry_card', {
        method: 'POST',
        body: body,
      })
    },
    /**
     * 批量更新养护卡（仅养护卡&次卡）内的项目到期日期
     * @param {*} body
     * @returns
     */
    updateItemExpirationDateApi (body) {
      return $fetch('upkeep/upkeep_expiry_item', {
        method: 'POST',
        body: body,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/customer.js